import { useState } from 'react';
import { Divider, Drawer, List, ListItemButton, Stack } from '@mui/material';
import { NAVBAR_HEIGHT, NavMenuOption } from './Navbar';
import { Menu } from '@mui/icons-material';
import { MHMIconButton } from '../MHM/MHMIconButton';
import { MobileLanguageSelector } from './MobileLanguageSelector';
import {
  PrivacyAndCookies,
  SupportEmail,
  SupportWhatsApp,
  TermsOfUse,
  Version,
} from '../Footer';
import { MHMTypography } from '../MHM/MHMTypography';
import { useTranslation } from '../../../contexts/TranslationContext';

type Props = { navMenuOptions: Array<NavMenuOption | null> };

export function MobileNavMenu({ navMenuOptions }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  function toggleIsOpen() {
    setIsOpen(o => !o);
  }

  function closeDrawer() {
    setIsOpen(false);
  }

  function handleOptionClick(onClick: () => void) {
    return () => {
      onClick();
      closeDrawer();
    };
  }

  return (
    <>
      <MHMIconButton
        aria-label="menu"
        color="appBarText"
        sx={{ p: 0, display: { xs: 'flex', sm: 'flex', md: 'none' } }}
        onClick={toggleIsOpen}
      >
        <Menu fontSize="large" />
      </MHMIconButton>
      <Drawer open={isOpen} anchor="right" onClose={closeDrawer}>
        <List sx={{ minWidth: '30vw', pt: `${NAVBAR_HEIGHT}px` }}>
          {navMenuOptions.map(option =>
            option ? (
              <ListItemButton
                key={option.state}
                onClick={handleOptionClick(option.onClick)}
              >
                {option.label}
              </ListItemButton>
            ) : null,
          )}
          <Divider />
          <ListItemButton>
            <PrivacyAndCookies />
          </ListItemButton>
          <ListItemButton>
            <TermsOfUse />
          </ListItemButton>
          <ListItemButton>
            <Stack direction="row" alignItems="center" gap={1}>
              <MHMTypography textAlign="center">{t('Support')}:</MHMTypography>
              <SupportEmail />
            </Stack>
          </ListItemButton>
          <ListItemButton>
            <Stack direction="row" alignItems="center" gap={1}>
              <MHMTypography textAlign="center">{t('Support')}:</MHMTypography>

              <SupportWhatsApp />
            </Stack>
          </ListItemButton>
          <ListItemButton>
            <Version />
          </ListItemButton>
          <Divider />
          <MobileLanguageSelector closeDrawer={closeDrawer} />
        </List>
      </Drawer>
    </>
  );
}
